import EntityImageActions from '../../entityImage/EntityImageActions';

const PoleImageActions = () => <EntityImageActions entityType="pole" />;

export default PoleImageActions;
